import { buildCareSpanLines } from '../../utils/lifecarePlanUtils';

const lineClasses = 'flex gap-1.5 whitespace-nowrap';

const lineLabelClasses = 'font-semibold text-subtle';

const FutureCareAgeYearCell = ({ row }) => (
    <>
        {buildCareSpanLines(row).map(({ label, text }) => (
            <div key={label} className={lineClasses}>
                <span className={lineLabelClasses}>{label}</span>
                <span>{text}</span>
            </div>
        ))}
    </>
);

export default FutureCareAgeYearCell;
